<template>
    <div class="qrcode-dialog" v-if="isShow">
        <div class="qrcode-container">
            <canvas class="wx-qrcode" ref="wechatPayCanvas" />
            <div class="desc">二维码30分钟有效，使用微信扫码支付</div>
            <div class="btns">
                <van-button @click="onClose">取消</van-button>
                <van-button color="#07c160" @click="onQueryPayStatus">我已支付</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { Button } from 'vant'

export default {
    components: { VanButton: Button },
    data() {
        return {
            isShow: false,
        }
    },
    methods: {
        onShow(codeUrl) {
            this.isShow = true
            this.$nextTick(() => {
                window.QRCode.toCanvas(
                    this.$refs.wechatPayCanvas,
                    codeUrl,
                    { width: 228, height: 228, margin: 2, errorCorrectionLevel: 'L' },
                    (err) => {
                        if (err) this.$toast('生成支付二维码失败，请稍后再试')
                    }
                )
            })
        },
        onClose() {
            this.isShow = false
        },

        onQueryPayStatus() {
            this.$emit('queryState')
        },
    },
}
</script>
<style lang="scss" scoped>
.qrcode-dialog {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
}
.qrcode-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 28px 24px 20px;
    background: #ffffff;
    border-radius: 4px;
    .wx-qrcode {
        width: 228px;
        height: 228px;
    }
    .desc {
        font-size: 13px;
        text-align: center;
        color: #666;
        margin: 12px 0 8px;
    }
    .btns {
        display: flex;
        justify-content: space-evenly;
        margin-top: 20px;
        width: 100%;
        > .van-button {
            height: 40px;
        }
    }
}
</style>
